export enum MediaTypes {
    Image = 'Image',
    Video = 'Video',
    Audio = 'Audio',
    Document = 'Document',
    Other = 'Other',
}
